import IconExclaimBubbleSvg from '../../common/components/icons/ExclaimBubble.svg';
import { Container, Title, Body, LinkButton, SVGWrapper } from './FeedbackSidebarSection.styles';

interface Props {
  className?: string;
}

export const FeedbackSidebarSection = ({ className }: Props) => (
  <Container className={className}>
    <SVGWrapper>
      <IconExclaimBubbleSvg />
    </SVGWrapper>
    <Title>Help us improve your experience</Title>
    <Body>This will only take 1-2 minutes.</Body>
    <LinkButton to="https://surveys.hotjar.com/s?siteId=30103&surveyId=124338" target="_blank">
      Give feedback
    </LinkButton>
  </Container>
);
